import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/**
 * declare routes with lazy loaded components
 */
const routes = [
  {
    path: '/success/:sellerId/:rewardId',
    name: 'successPageSepa',
    component: () => import('@/views/Success')
  },
  {
    path: '/success/:sellerId/:rewardId',
    name: 'successPage',
    component: () => import('@/views/Success')
  },
  {
    path: '/success/:rewardId',
    name: 'successPageV2',
    component: () => import('@/views/Success')
  },
  {
    path: '/sold/:sellerId/:rewardId',
    name: 'soldOut',
    component: () => import('@/views/Sold')
  },
  {
    path: '/sepa/:rewardId/:buyerId',
    name: 'sepa',
    component: () => import('@/views/Paynow')
  },
  {
    path: '/card/:rewardId/:buyerId',
    name: 'card',
    component: () => import('@/views/Paynow')
  },
  {
    path: '/:rewardId/:buyerId',
    name: 'index',
    component: () => import('@/views/Index')
  },
  {
    path: '/:rewardId',
    name: 'landingpage',
    component: () => import('@/views/Index')
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/views/404')
  }
]

/**
 * scroll to top on every click
 */
const scrollBehavior = (to, from, savedPosition) => ({ x: 0, y: 0 })

/**
 * init router
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes
})

/**
 * guard routes
 */
// router.beforeEach(async (to, from, next) => {
//   if (to.matched.some(route => route.meta.isPublic)) {
//     return next()
//   }
//   const isValidUser = await store.dispatch('auth/verifyUser')
//   if (isValidUser) {
//     return next()
//   }
//   return next({
//     name: 'login'
//   })
// })

export default router
